import { Navigate } from "react-router-dom";

const SESSION_KEY = "baptism_admin_token";

export default function ProtectedRoute({ children }) {
  const isAuthenticated = localStorage.getItem(SESSION_KEY) === "true";
  return isAuthenticated ? children : <Navigate to="/baptism/admin/login" replace />;
}
